import React from "react";
import Sidebar from "./Sidebar";
import Main from "./Main";
import Header from "./Header";
import AudioPlayer from "../../containers/Audio";
import styles from "./index.module.scss"

export default () => (
  <React.Fragment>
    <Header />
    <div className={styles.layout}>
      <Sidebar />
      <Main />
      <AudioPlayer />
    </div>
  </React.Fragment>
)